import React, { createContext } from 'react'

export const DropDownCtx = createContext<{
  setOpen: ((open: boolean) => void) | null
  isOpen: boolean | null
}>({
  setOpen: null,
  isOpen: null,
})

const DropDownProvider = ({
  setOpen,
  isOpen,
  children,
}: {
  setOpen: (open: boolean) => void
  isOpen: boolean
  children: React.ReactNode
}) => (
  <DropDownCtx.Provider
    value={{
      setOpen,
      isOpen,
    }}
  >
    {children}
  </DropDownCtx.Provider>
)

export default DropDownProvider
